import React, { useState, useEffect } from 'react';
import { ProductGrid, Pagination } from '../../components/organisms';
import apiService from '../../services/api';

/**
 * Products Page Component
 */
const ProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [paginationInfo, setPaginationInfo] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await apiService.getAllProducts({ page: currentPage });
        console.log('Products response:', response);
        
        // Extract pagination info
        const pagination = response?.data || {};
        setPaginationInfo(pagination);
        setTotalPages(pagination.pages || 1);
        
        // Extract products from response.data.products
        const productsData = pagination.products || [];
        
        // Flatten products - extract articles (variants) from each product
        const flattenedProducts = productsData.flatMap((product) => {
          if (!product.articles || product.articles.length === 0) {
            return [];
          }
          
          // Map each article to a displayable product
          return product.articles.map((article) => ({
            id: article.pharmacode || product._id,
            _id: product._id,
            pharmacode: article.pharmacode,
            longDescription: article.longDescription,
            currentPrice: article.price?.currentPrice,
            originalPrice: article.price?.originalPrice,
            inDiscount: article.price?.inDiscount,
            discountPercentage: article.price?.discountPercentage,
          }));
        });
        
        setProducts(flattenedProducts);
        setError(null);
      } catch (err) {
        console.error('Error fetching products:', err);
        setError('Failed to load products');
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // Scroll to top when page changes
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleAddToCart = (productId) => {
    console.log('Add to cart:', productId);
    // Add your cart logic here
  };

  return (
    <div className="min-h-screen">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Products</h1>
        
        {loading && (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">Loading products...</p>
          </div>
        )}

        {error && (
          <div className="text-center py-12">
            <p className="text-red-500 text-lg">{error}</p>
          </div>
        )}

        {!loading && !error && (
          <>
            <ProductGrid 
              products={products} 
              onAddToCart={handleAddToCart}
            />
            
            {paginationInfo && (
              <div className="mt-8">
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ProductsPage;

